<template>
  <div class="chart-container">
    <!-- 图表类型切换工具栏 -->
    <div class="chart-tools">
      <div
        v-for="item in chartTypeList"
        :key="item.value"
        class="chart-tools-item"
        :class="{ selected: chartType === item.value }"
        @click="changeChartType(item.value)"
      >
        <img
          class="chart-tools-item-img"
          :src="chartType === item.value ? item.activeIcon : item.icon"
          alt=""
        />
        <span class="chart-tools-item-text">{{ item.label }}</span>
      </div>
    </div>

    <!-- 图表容器 -->
    <div class="chart-box">
      <div
        v-show="chartType !== 3"
        ref="lineBarChart"
        class="chart-wrapper"
      ></div>
      <div v-show="chartType === 3" ref="pieChart" class="chart-wrapper"></div>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";

// 图表类型配置
const CHART_TYPE_LIST = [
  {
    value: 1,
    label: "折线图",
    icon: "https://ossfastmake.mustke.com/12jielong/bdJL/zxt.svg",
    activeIcon: "https://ossfastmake.mustke.com/12jielong/bdJL/zxt-s.svg",
  },
  {
    value: 2,
    label: "柱状图",
    icon: "https://ossfastmake.mustke.com/12jielong/bdJL/zzt.svg",
    activeIcon: "https://ossfastmake.mustke.com/12jielong/bdJL/zzt-s.svg",
  },
  {
    value: 3,
    label: "饼状图",
    icon: "https://ossfastmake.mustke.com/12jielong/bdJL/bzt.svg",
    activeIcon: "https://ossfastmake.mustke.com/12jielong/bdJL/bzt-s.svg",
  },
];

export default {
  name: "ChartItem",
  props: {
    optionObj: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      chartType: 1,
      chartTypeList: CHART_TYPE_LIST,
      lineBarChart: null,
      pieChart: null,
    };
  },
  watch: {
    optionObj: {
      handler() {
        this.renderChart();
      },
      deep: true,
    },
  },
  methods: {
    changeChartType(type) {
      if (this.chartType === type) return;
      this.chartType = type;
      this.$nextTick(() => {
        this.renderChart();
      });
    },
    renderChart() {
      const { options = [], question = "" } = this.optionObj;
      const categories = options.map((item) => item.label);
      const data = options.map((item) => item.count);

      if (this.chartType === 3) {
        // 饼图
        this.initPieChart(categories, data);
      } else {
        // 折线图/柱状图
        this.initLineBarChart(categories, data);
      }
    },
    initLineBarChart(categories, data) {
      if (!this.$refs.lineBarChart) return;

      if (this.lineBarChart) {
        this.lineBarChart.dispose();
      }

      this.lineBarChart = echarts.init(this.$refs.lineBarChart);

      const { question = "" } = this.optionObj;

      const option = {
        tooltip: {
          trigger: "axis",
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          top: "10%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          data: categories,
          axisLabel: {
            interval: 0,
            rotate: 0,
            // width: 0,
            overflow: "break",
            formatter: (value) => {
              return value.length > 8 ? value.slice(0, 4) + "..." : value;
            },
          },
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            name: question.split("/")[0],
            type: this.chartType === 1 ? "line" : "bar",
            data: data,
            // smooth: true,
            barWidth: "30%",
            barGap: "50%",
            itemStyle: {
              color: "#1877ff",
            },
            lineStyle: {
              color: "#1877ff",
              width: 2,
            },
            // areaStyle:
            //   this.chartType === 1
            //     ? {
            //         color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            //           { offset: 0, color: "rgba(24, 119, 255, 0.3)" },
            //           { offset: 1, color: "rgba(24, 119, 255, 0.01)" },
            //         ]),
            //       }
            //     : null,
          },
        ],
      };

      this.lineBarChart.setOption(option);
    },
    initPieChart(categories, data) {
      if (!this.$refs.pieChart) return;

      if (this.pieChart) {
        this.pieChart.dispose();
      }

      this.pieChart = echarts.init(this.$refs.pieChart);

      const { question = "" } = this.optionObj;

      const option = {
        title: {
          show: false,
        },
        tooltip: {
          trigger: "item",
        },
        legend: {
          orient: "vertical",
          left: "left",
          top: "middle",
          formatter: (name) => {
            return name.length > 8 ? name.slice(0, 8) + "..." : name;
          },
        },
        series: [
          {
            name: question.split("/")[0],
            type: "pie",
            radius: ["40%", "70%"],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 5,
              borderColor: "#fff",
              borderWidth: 2,
            },
            label: {
              show: false,
              position: "center",
            },
            emphasis: {
              label: {
                show: false,
              },
            },
            labelLine: {
              show: false,
            },
            data: categories.map((name, index) => ({
              name: name,
              value: data[index],
            })),
          },
        ],
      };

      this.pieChart.setOption(option);
    },
    handleResize() {
      if (this.lineBarChart) {
        this.lineBarChart.resize();
      }
      if (this.pieChart) {
        this.pieChart.resize();
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.renderChart();
    });
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
    if (this.lineBarChart) {
      this.lineBarChart.dispose();
      this.lineBarChart = null;
    }
    if (this.pieChart) {
      this.pieChart.dispose();
      this.pieChart = null;
    }
  },
};
</script>

<style lang="scss" scoped>
.chart-container {
  background: #fff;
  border-radius: 8px;
  padding: 10px;

  .chart-tools {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 8px;
    margin-bottom: 10px;

    &-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 4px;
      cursor: pointer;
      padding: 4px 8px;
      border-radius: 4px;
      transition: all 0.3s;

      &-img {
        width: 28px;
        height: 28px;
      }

      &-text {
        font-size: 12px;
        color: #989fac;
      }

      &:hover {
        background-color: #f5f5f5;
      }

      &.selected {
        background-color: #f0f7ff;

        .chart-tools-item-text {
          color: #20263b;
          font-weight: bold;
        }
      }
    }
  }

  .chart-box {
    position: relative;
    height: 280px;
    width: 100%;
  }

  .chart-wrapper {
    width: 100%;
    height: 100%;
  }
}
</style>
